import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_Branch = forwardRef((props, ref) => {

    const toaster = rsuite.useToaster();

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState(General.GuidEmpty());
    const Branch_Onchange = (value) => {
        props.onChange(value == null ? General.GuidEmpty() : value, value == null ? "" : List.find(x => x.Id == value).Title)
        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(id) {
            var isDefault = 0
            var RequestOptions = {
                url: General.ApiRoute() + "/Branch/Search",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    "IsActive": 1,
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var temp = [];
                        console.dir(result)
                        for (let index = 0; index < result.data.length; index++) {
                            temp.push({
                                Id: result.data[index].id,
                                Title: result.data[index].title
                            })

                            if ((result.data[index].isDefault == 1 && result.data[index].isOnline == 0 && id == General.GuidEmpty()) || result.data[index].id == id) {
                                props.onChange(result.data[index].id, result.data[index].title)
                                setId(result.data[index].id);
                                isDefault = 1;
                            }
                            else if (isDefault == 0)
                                setId(id);

                        }
                        setList(temp);


                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )


        },

    }))



    return (

        <rsuite.SelectPicker
            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => Branch_Onchange(value)}

        />


    )
});

export default Drp_Branch;